/* 88 Acres product page - "About this flavor" read more toggle (sections/pdp-details-88.liquid). */
(function () {
  'use strict';
  function init(root) {
    if (root.hasAttribute('data-pdp-acc-ready')) return;
    root.setAttribute('data-pdp-acc-ready', '');
    var desc = root.querySelector('[data-pdp-desc]');
    var btn = root.querySelector('[data-pdp-more]');
    if (!desc || !btn) return;
    var check = function () {
      if (root.classList.contains('is-expanded')) return;
      btn.hidden = desc.scrollHeight <= desc.clientHeight + 2;
    };
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
    check();
    window.addEventListener('resize', check);
  }
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-acc]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
